import {
  ALERT_COPY_COLUMN_CLASS_MAP,
  ALERT_ASSET_GRID_CLASS_MAP,
  TAlertAsset,
} from "./Alert.config";
import { isAlertAssetIconKey } from "./Alert.guards";

export const getAlertAssetGridClass = (asset: TAlertAsset | undefined) => {
  if (!asset) { return ALERT_ASSET_GRID_CLASS_MAP.default; }
  if (isAlertAssetIconKey(asset)) { return ALERT_ASSET_GRID_CLASS_MAP.withIcon; }
  return ALERT_ASSET_GRID_CLASS_MAP.default;
};


export const getAlertCopyColumnClass = (asset: TAlertAsset | undefined) => (
  asset ? ALERT_COPY_COLUMN_CLASS_MAP.withAsset : ALERT_COPY_COLUMN_CLASS_MAP.default
);
